import React, { FC, RefObject, useEffect, useRef, useState } from "react";
import { ReactComponent as ChevronDownIcon } from "assets/images/chevron-down-new.svg";
import { ReactComponent as GraduationCapIcon } from "assets/images/graduation-cap.svg";
import { UserCareerStage } from "generated/graphql";
import { SearchInput } from "components/molecules/FolderDropdown/styles";
import { useTranslation } from "react-i18next";
import {
  Caption,
  Dropdown,
  DropdownElement,
  DropdownWrapper,
  CareerStageItem,
  CareerStageList,
  SearchInputWrapper,
} from "./styles";

import { Props } from "./types";

const careerStages = [
  {
    id: UserCareerStage.CareerStarter,
    name: "Secondary School Student",
    value: UserCareerStage.CareerStarter,
  },
  {
    id: UserCareerStage.CareerChanger,
    name: "Adult",
    value: UserCareerStage.CareerChanger,
  },
  // {
  //   id: UserCareerStage.CareerDeveloper,
  //   name: "Career Developer (Looking to Advance)",
  //   value: UserCareerStage.CareerDeveloper,
  // },
];

const AssignToCareerStage: FC<Props> = ({ onCareerStageSelect }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const { t } = useTranslation();
  const [careerStageSearch, setCareerStageSearch] = useState("");

  const handleClick = (careerStage: UserCareerStage) => {
    onCareerStageSelect(careerStage);
    setDropdownVisible(false);
  };

  const handleChange = (e: any) => setCareerStageSearch(e.target.value);

  useEffect(() => {
    function handleClickOutside(
      event: MouseEvent,
      localRef: RefObject<HTMLElement>
    ) {
      if (
        ref &&
        ref.current &&
        localRef === ref &&
        localRef.current &&
        !localRef.current.contains(event.target as HTMLElement)
      ) {
        setDropdownVisible(false);
      }
    }

    document.addEventListener("mouseup", (e) => handleClickOutside(e, ref));
    return () => {
      document.removeEventListener("mouseup", (e) =>
        handleClickOutside(e, ref)
      );
    };
  }, [ref, setDropdownVisible]);

  return (
    <DropdownElement ref={ref}>
      <DropdownWrapper onClick={() => setDropdownVisible(!dropdownVisible)}>
        <GraduationCapIcon style={{ width: "18px", height: "18px" }} />
        <Caption>Assign career stage</Caption>
        <ChevronDownIcon
          style={{
            rotate: dropdownVisible ? "180deg" : "0deg",
            transition: "all 0.2s ease-in",
          }}
        />
      </DropdownWrapper>
      {dropdownVisible && (
        <>
          <Dropdown>
            <SearchInputWrapper>
              <SearchInput
                placeholder="Search career stages..."
                onChange={handleChange}
                style={{ width: "100%" }}
              />
            </SearchInputWrapper>
            <CareerStageList>
              {careerStages
                ?.filter((stage) =>
                  stage.name
                    ?.toLowerCase()
                    .includes(careerStageSearch.toLowerCase())
                )
                .map((stage) => (
                  <CareerStageItem
                    key={stage.id}
                    onClick={() => handleClick(stage.value)}
                  >
                    {stage.name}
                  </CareerStageItem>
                ))}
            </CareerStageList>
          </Dropdown>
        </>
      )}
    </DropdownElement>
  );
};

export default AssignToCareerStage;
